<template>
  <div>
    <v-toolbar dark prominent>
      <v-app-bar-nav-icon>
        <v-icon color="blue darken-2" @click="backButton">
          mdi-arrow-left
        </v-icon>
      </v-app-bar-nav-icon>

      <v-col cols="10" md="11" sm="12">
        <v-img src="/img/fantasy_lineups_logo.png" class="logo mx-auto" width="300" contain />
      </v-col>
    </v-toolbar>

    <v-tabs v-model="tab" background-color="#32cd32" dark centered class="mb-2 tab-row">
      <v-tabs-slider color="#17408B"></v-tabs-slider>
      <v-tab href="#games"> Games Bet</v-tab>
      <v-tab href="#props"> Props Bet</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-col cols="12" class="mx-auto mt-4 text-center">
        <v-btn-toggle color="#73c603" v-model="sportId" dense mandatory>
          <v-btn :value="4">NFL</v-btn>
          <v-btn :value="2">MLB</v-btn>
        </v-btn-toggle>
      </v-col>

      <v-col cols="12" class="mx-auto mb-5 text-center">
        <v-btn-toggle color="#73c603" v-model="toggle_exclusive" dense mandatory>
          <v-btn>Chazmule</v-btn>
          <v-btn>doughboys123</v-btn>
        </v-btn-toggle>
      </v-col>

      <!-- Shared UI -->
      <v-col cols="12" class="mx-auto mb-5 text-center">
        <!-- Games -->
        <v-tab-item value="games">
          <v-col cols="12" md="7" class="mx-auto">
            <v-sheet class="ma-5 pa-3" elevation="3" rounded>
              <v-col>
                <strong class="text-h5">Gold</strong>
                <wysiwyg v-model="activeGameBet.gold" />
              </v-col>

              <v-col>
                <strong class="text-h5">Silver</strong>
                <wysiwyg v-model="activeGameBet.silver" />
              </v-col>

              <v-col>
                <strong class="text-h5">Bronze</strong>
                <wysiwyg v-model="activeGameBet.bronze" />
              </v-col>

              <v-col>
                <strong class="text-h5">Remark</strong>
                <wysiwyg v-model="activeGameBet.remark" />
              </v-col>

              <v-col>
                <v-btn block color="success" @click="sendUserGameBet">
                  Submit
                </v-btn>
              </v-col>
            </v-sheet>
          </v-col>
        </v-tab-item>

        <!-- Props -->
        <v-tab-item value="props">
          <v-col cols="12" md="7" class="mx-auto">
            <v-sheet class="ma-5 pa-3" elevation="3" rounded>
              <v-col>
                <strong class="text-h5">Gold</strong>
                <wysiwyg v-model="activePropsBet.gold" />
              </v-col>

              <v-col>
                <strong class="text-h5">Silver</strong>
                <wysiwyg v-model="activePropsBet.silver" />
              </v-col>

              <v-col>
                <strong class="text-h5">Bronze</strong>
                <wysiwyg v-model="activePropsBet.bronze" />
              </v-col>

              <v-col>
                <strong class="text-h5">Remark</strong>
                <wysiwyg v-model="activePropsBet.remark" />
              </v-col>

              <v-col>
                <v-btn block color="success" @click="sendUserPropsBet">
                  Submit
                </v-btn>
              </v-col>
            </v-sheet>
          </v-col>
        </v-tab-item>
      </v-col>
    </v-tabs-items>
  </div>
</template>

<script>
export default {
  name: "bestBetForm",

  data() {
    return {
      tab: null,
      toggle_exclusive: 0,
      sportId: 4,

      // separate request trackers
      gameRequestId: 0,
      propsRequestId: 0,

      chazumle: {
        gameBet: { gold: "", silver: "", bronze: "", remark: "" },
        propsBet: { gold: "", silver: "", bronze: "", remark: "" },
      },

      doughboys: {
        gameBet: { gold: "", silver: "", bronze: "", remark: "" },
        propsBet: { gold: "", silver: "", bronze: "", remark: "" },
      },
    };
  },

  computed: {
    currentUserId() {
      return this.toggle_exclusive === 0
        ? "6107f818963dc87f216fa505"
        : "60fedc56109bcffeb7010994";
    },

    activeGameBet() {
      return this.toggle_exclusive === 0
        ? this.chazumle.gameBet
        : this.doughboys.gameBet;
    },

    activePropsBet() {
      return this.toggle_exclusive === 0
        ? this.chazumle.propsBet
        : this.doughboys.propsBet;
    },
  },

  mounted() {
    this.handleClick(this.currentUserId);
  },

  watch: {
    sportId() {
      this.handleClick(this.currentUserId);
    },

    toggle_exclusive() {
      this.handleClick(this.currentUserId);
    },
  },

  methods: {
    backButton() {
      this.$router.go(-1);
    },

    handleClick(userId) {
      this.setGameBet(userId);
      this.setPropsBet(userId);
    },

    getGameBetTarget(userId) {
      return userId === "6107f818963dc87f216fa505"
        ? this.chazumle.gameBet
        : this.doughboys.gameBet;
    },

    getPropsBetTarget(userId) {
      return userId === "6107f818963dc87f216fa505"
        ? this.chazumle.propsBet
        : this.doughboys.propsBet;
    },

    resetBet(target) {
      target.gold = "";
      target.silver = "";
      target.bronze = "";
      target.remark = "";
    },

    async setGameBet(id) {
      const requestSportId = this.sportId;
      const target = this.getGameBetTarget(id);
      const currentRequest = ++this.gameRequestId;

      this.resetBet(target);

      const response = await this.$store.dispatch("userModule/getBestBet", {
        sportId: requestSportId,
        id,
      });

      if (currentRequest !== this.gameRequestId) return;
      if (requestSportId !== this.sportId || id !== this.currentUserId) return;

      if (response?.doc) {
        Object.assign(target, {
          gold: response.doc.gold || "",
          silver: response.doc.silver || "",
          bronze: response.doc.bronze || "",
          remark: response.doc.remark || "",
        });
      }
    },

    async setPropsBet(id) {
      const requestSportId = this.sportId;
      const target = this.getPropsBetTarget(id);
      const currentRequest = ++this.propsRequestId;

      this.resetBet(target);

      const response = await this.$store.dispatch("userModule/getBestBetProps", {
        sportId: requestSportId,
        id,
      });

      if (currentRequest !== this.propsRequestId) return;
      if (requestSportId !== this.sportId || id !== this.currentUserId) return;

      if (response?.doc) {
        Object.assign(target, {
          gold: response.doc.gold || "",
          silver: response.doc.silver || "",
          bronze: response.doc.bronze || "",
          remark: response.doc.remark || "",
        });
      }
    },

    sendUserGameBet() {
      this.$store.dispatch("userModule/saveBestBet", {
        sportId: this.sportId,
        id: this.currentUserId,
        ...this.activeGameBet,
      });
    },

    sendUserPropsBet() {
      this.$store.dispatch("userModule/saveBestBetProps", {
        sportId: this.sportId,
        id: this.currentUserId,
        ...this.activePropsBet,
      });
    },
  },
};
</script>

<style>
@import "~vue-wysiwyg/dist/vueWysiwyg.css";
</style>
